<template>
  <div>
    <router-view v-slot="{ Component, route }">
      <transition name="fade">
        <keep-alive>
          <component :is="Component" :key="route.path" />
        </keep-alive>
      </transition>
    </router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from "@/i18n";
import store from "../store/index";
export default {
  name: "KeepMeAliveView",

  computed: {
    ...mapGetters(["getEditing", "getCookieStatus"]),
  },
  methods: {
    ...mapActions(["setEditing", "setCookieStatus", "setAcceptToS"]),
  },

  beforeRouteLeave(to, from, next) {
    if (!this.getEditing) {
      if (!window.confirm(i18n.global.t("wantToLeave"))) {
        return;
      }
    }
    var cookieStat = this.getCookieStatus;
    this.$store.reset();
    this.$store.dispatch("setAcceptToS", true);
    this.$store.dispatch("setCookieStatus", cookieStat);
    next();
  },
  beforeRouteEnter(to, from) {
  if (String(to.path).includes("metadata")){  
  const canAccess = store.getters["getAcceptToS"]
  if (!canAccess) return '/'
  }
},
 
};
</script>
<style>
.rldisabled {
  opacity: 0.3;
  pointer-events: none;
}
</style>
